export const categories = [
    {
        name: "Herbal Products",
        img: "https://st.depositphotos.com/1978037/1886/i/450/depositphotos_18868379-stock-photo-alternative-medicine.jpg"
    },
    {
        name: "Supplements",
        img: "https://recreation.ucsd.edu/wp-content/uploads/2020/09/supplements-1200x800-1.jpg"
    },
    {
        name: "Sport",
        img: "https://www.burgerstein-foundation.ch/temp/thumbnails/jogging_people-d64c7.jpg"
    },
    {
        name: "Probiotics",
        img: "https://upfit.de/wp-content/uploads/2020/06/upfit-supplement-beitragsbild.jpg"
    },
    {
        name: "Vitamins",
        img: "https://www.priceline.com.au/media/wysiwyg/Vitamins_to_boost_your_wellbeing_hero.jpg"
    },
]

export const products = [
    {
        id: 1,
        category: "Herbal Products",
        title: "Pure Rosehip Seed Oil, 1 oz (30 ml)",
        img: "https://e-c.storage.googleapis.com/res/212989e2-a6db-4270-b7bf-6c10627b34d1/original",
        price: 5.00,
        currency: "USD",
        description: "A saturated, amber oil from the ripened fruit of the hips rose species. The oil contains natural Retinol Acid (Vitamin A) and can be used for replenishing and restoring mature or sun-exposed skin. Use: Apply 2-3 drops onto your fingertips and massage into cleansed, dry skin.You can also use it as an oil for general body or scalp massage. Other ingredients: organic rosa mosqueta(rose hip) seed oil(99%), tocopherol(vitamin E)."
    },
    {
        id: 2,
        category: "Herbal Products",
        title: "Elderberry Syrup, 7.8 fl oz (230 ml)",
        img: "https://e-c.storage.googleapis.com/res/21238066-b0d6-44c9-8691-483558770330/original",
        price: 15.00,
        currency: "USD",
        description: "This syrup provides strong immune system support to help your kids stay healthy throughout the year. The berry flavor is great for kids who usually don't like to take meds. Other ingredients: glucose syrup, purified water, citric acid, potassium sorbate",
    },
    {
        id: 3,
        category: "Herbal Products",
        title: "Cranberry Plus, 60 tablets",
        img: "https://e-c.storage.googleapis.com/res/93d49583-f100-40cc-8a89-495a081fbaf1/original",
        price: 20.00,
        currency: "USD",
        description: "This syrup provides strong immune system support to help your kids stay healthy throughout the year. The berry flavor is great for kids who usually don't like to take meds. Other ingredients: glucose syrup, purified water, citric acid, potassium sorbate"
    },
    {
        id: 4,
        category: "Herbal Products",
        title: "Cordyceps CS-4 Strain, 60 capsules",
        img: "https://e-c.storage.googleapis.com/res/d6d4f559-5e90-4996-980f-1750c79a7ffb/original",
        price: 10.00,
        currency: "USD",
        description: "A saturated, amber oil from the ripened fruit of the hips rose species. The oil contains natural Retinol Acid (Vitamin A) and can be used for replenishing and restoring mature or sun-exposed skin. Use: Apply 2-3 drops onto your fingertips and massage into cleansed, dry skin.You can also use it as an oil for general body or scalp massage. Other ingredients: organic rosa mosqueta(rose hip) seed oil(99%), tocopherol(vitamin E)."
    },
    {
        id: 5,
        category: "Supplements",
        title: "Hydrolyzed Collagen + Hyaluronic Acid + Vitamin C, 7.26 oz",
        img: "https://e-c.storage.googleapis.com/res/64777bf9-da45-411c-a0d0-095bcba3c137/original",
        price: 5.00,
        currency: "USD",
        description: "Collagen, Hyaluronic Acid and vitamin C are needed for the wellbeing of the musculoskeletal system. Together all these 3 ingredients can boost your health, the quality of your hair, nails, etc."
    },
    {
        id: 6,
        category: "Supplements",
        title: "Immune 4, Immune System Support, 60 capsules",
        img: "https://e-c.storage.googleapis.com/res/d6d513ce-f500-4c1e-a5da-28a26a9461a1/original",
        price: 10.00,
        currency: "USD",
        description: "This supplement product contains 4 main elements: Vitamin C, Vitamin D, Zinc, and Selenium. This combination can protect your immune system from viruses and bacteria, respiratory infections, etc."
    },
    {
        id: 7,
        category: "Supplements",
        title: "Strawberry Soothing Syrup, Berry Flavored, 4 fl oz (120 ml)",
        img: "https://e-c.storage.googleapis.com/res/25bf7558-6048-42cc-a1b7-d64d2fdfd5f1/original",
        price: 15.00,
        currency: "USD",
        description: "This syrup relieves symptoms and reduces their severity in case of cough, minor aches/ pains, sore throat, fever, runny nose, etc.The product is suitable for children."
    },
    {
        id: 8,
        category: "Supplements",
        title: "Digestive Enzymes, Broad Spectrum, 90 capsules",
        img: "https://e-c.storage.googleapis.com/res/81240948-3fc8-422d-8cbe-1383bd81242c/original",
        price: 10.00,
        currency: "USD",
        description: "These enzymes prepare your body to break down food and absorb nutrients. Continuous use of this supplement will reduce unpleasant digestive symptoms such as bloating, indigestion and irregularity, occasional gas."
    },
    {
        id: 9,
        category: "Sport",
        title: "Branched-Chain Amino Acids, 240 capsules",
        img: "https://e-c.storage.googleapis.com/res/b2f12e01-ea83-4987-b986-0d0c6cc7a5c3/original",
        price: 5.00,
        currency: "USD",
        description: "This product supports muscle growth and recovery. It is recommended to take it after injuries, operations, before exercises, and so on."
    },
    {
        id: 10,
        category: "Sport",
        title: "L-Carnitine, 3000, Berry, 16 fl oz (473 ml)",
        img: "https://e-c.storage.googleapis.com/res/4cb55fd7-2c58-4783-9b4e-5f7501e5085a/original",
        price: 10.00,
        currency: "USD",
        description: "This supplements gives you energy, better performance, and helps you to achieve better results when training.Other ingredients: citric acid, potassium sorbate, purified water, sucralose, phosphoric acid, natural & artificial flavor, dl-malic acid, acesulfame potassium, sodium benzoate."
    },
    {
        id: 11,
        category: "Sport",
        title: "Ionic Minerals, Electrolytes, Liquid Concentrate, 2 oz (60 ml)",
        img: "https://e-c.storage.googleapis.com/res/2f8a7532-400e-426f-a3f5-2549aedef765/original",
        price: 15.00,
        currency: "USD",
        description: "This concentrate is a mineral dietary supplement consisting of all essential electrolytes needed for maintaining a proper electrical circuit in our bodies. The electrolytes are in a rapidly absorbable form."
    },
    {
        id: 12,
        category: "Sport",
        title: "Micronized Creatine Capsules, 2.5 g, 200 capsules",
        img: "https://e-c.storage.googleapis.com/res/ad43ace1-bda3-4e53-89ca-a35df80ececc/original",
        price: 20.00,
        currency: "USD",
        description: "This product is essential for muscle building support. It contains 2.5 g of 100% pure Creatine Monohydrate - this is one of the most common ingredients to support ATP recycling for explosive movements."
    },
    {
        id: 13,
        category: "Probiotics",
        title: "Ultimate Probiotic, Senior's, 35 Billion CFU, 30 capsules",
        img: "https://e-c.storage.googleapis.com/res/8d8f7fe6-8f72-4e2f-95e5-5097b553dad7/original",
        price: 5.00,
        currency: "USD",
        description: "This dietary supplement has a premium formula for the aging gut. It brings balance to your microflora and helps you feel better after every meal."
    },
    {
        id: 14,
        category: "Probiotics",
        title: "LactoBif Probiotics, 5 Billion CFU, 60 capsules",
        img: "https://e-c.storage.googleapis.com/res/14bd5aae-8ee0-4838-91c3-ccabd657e266/original",
        price: 10.00,
        currency: "USD",
        description: "This product contains eight active probiotic strains (5 Lactobacilli & 3 Bifidobacteria) with unique formula. The supplement helps with the digestion of food."
    },
    {
        id: 15,
        category: "Probiotics",
        title: "Acidophilus Probiotic Blend, 150 capsules",
        img: "https://e-c.storage.googleapis.com/res/8b899aac-3b87-4331-bd1f-6c2f36f61321/original",
        price: 15.00,
        currency: "USD",
        description: "This blend is designed for supporting healthy intestinal flora. It contains Lactobacillus acidophilus combined with 3 other probiotic organisms and the prebiotic Inulin."
    },
    {
        id: 16,
        category: "Probiotics",
        title: "Probiotic-10, 50 Billion, 50 capsules",
        img: "https://e-c.storage.googleapis.com/res/d4263292-2df8-4538-a0d9-fbae1b72e35f/original",
        price: 20.00,
        currency: "USD",
        description: "This product has a balanced spectrum of live organisms that colonize the human GI tract. Probiotics are needed for healthy digestion and detoxification."
    },
    {
        id: 17,
        category: "Vitamins",
        title: "Gold C, Vitamin C, 1,000 mg, 60 capsules",
        img: "https://e-c.storage.googleapis.com/res/e23b0662-a9bd-4bb6-b779-f6e575d83f4c/original",
        price: 5.00,
        currency: "USD",
        description: "This product is USP Grade L-Ascorbic Acid. Contains no gluten, no soy, no GMOs. Is suitable for vegans and vegetarians."
    },
    {
        id: 18,
        category: "Vitamins",
        title: "Vitamin D3, 125 mcg (5,000 IU), 90 softgels",
        img: "https://e-c.storage.googleapis.com/res/aeb975fc-a287-442b-a346-5d7f46a08673/original",
        price: 10.00,
        currency: "USD",
        description: "Vitamin D3 is the form of vitamin D best absorbed by human body. Vitamin D3 should be taken by those who need to regulate the absorption of calcium and phosphorous, and to support the immune system."
    },
    {
        id: 19,
        category: "Vitamins",
        title: "Vitamin D3 + K2, Soy Free, 125 mcg (5,000 IU), 60 capsules",
        img: "https://e-c.storage.googleapis.com/res/4035bcae-e317-4ac2-9979-cb609c68b0f9/original",
        price: 15.00,
        currency: "USD",
        description: "This product combines D-3 Cholecalciferol with K-2 Menaquinone-7 (MK-7) made from fermented chickpea. These vitamins work together in your body to support bone and cardiovascular health and maintain normal calcium levels."
    },
    {
        id: 20,
        category: "Vitamins",
        title: "Vitamin D3, Natural Berry Flavor, 1 fl oz (30 ml)",
        img: "https://e-c.storage.googleapis.com/res/bb28bf10-e805-4cc0-a261-cbdd2f9bcf52/original",
        price: 5.00,
        currency: "USD",
        description: "This vitamin D3 product is made especially for children. It is alcohol free, has natural ingredients and great berry flavor and taste."
    }
]